import { Injectable } from '@angular/core';

import { Api } from '../api/api';

import { Observable } from 'rxjs/Observable';

@Injectable()
export class MaintenanceProvider {
  url: string = "maintenance";

  constructor(private api: Api) {
  }

  check(): Observable<any> {
    return this.api.get(this.url);
  }

}



// WEBPACK FOOTER //
// ./src/providers/maintenance/maintenance.ts